import React from 'react'
import { i18n } from '../../validator'
import Configurator from '../../configurator'
import Image from '../shared/webp-image'

@i18n()
export default class ApiOffline extends Configurator {
    /**
     * Render content
     *
     * @return {*}
     */
    renderContent = () => {
        const { t } = this.props

        return (
            <div className="d-flex flex-row flex-wrap align-items-center justify-content-center p-5">
                <div className="col-12 col-md-8 align-items-center justify-content-center text-center">
                    <h2 className="landing font-weight-bold">
                        {t('apiOffline.title')}
                    </h2>

                    <div className="text-color-brand font-size-xl font-primary my-4" dangerouslySetInnerHTML={{ __html: t('apiOffline.timeout') }} />

                    <div dangerouslySetInnerHTML={{ __html: t('apiOffline.thanks') }} />
                </div>
                <div className="col-12 col-md-4 d-md-flex d-none">
                    <Image
                        src="/images/features/ales-timeout.svg"
                        defaultSrc="/images/features/ales-timeout.svg"
                        className="mw-100 mh-100 d-block flex-0"
                    />
                </div>
            </div>
        )
    }

    /**
     * Render
     *
     * @return {*}
     */
    render = () => {
        return (
            <div className="d-flex w-100 h-100 align-items-center justify-content-center">
                <div className="api-checker-container">
                    {this.renderContent()}
                </div>
            </div>
        )
    }
}
